import styled, {css, DefaultTheme} from 'styled-components'
import {ProgressBarProps} from './ProgressBar'

export type StyledProgressBarProps = {
    $rounded?: ProgressBarProps['rounded']
    $variant: NonNullable<ProgressBarProps['variant']>
}

export const makeProgressbarVariantStyle = (theme: DefaultTheme) =>
    ({
        primary: css`
            background-color: ${theme.palette.primary[100]};
        `,
        neutral: css`
            background-color: ${theme.palette.neutral[100]};
        `,
        danger: css`
            background-color: ${theme.palette.danger[100]};
        `,
        success: css`
            background-color: ${theme.palette.success[100]};
        `
    }) as const satisfies Record<NonNullable<StyledProgressBarProps['$variant']>, ReturnType<typeof css>>

export const makeProgressbarIndicatorVariantStyle = (theme: DefaultTheme) =>
    ({
        primary: css`
            background-color: ${theme.palette.primary[400]};
        `,
        neutral: css`
            background-color: ${theme.palette.neutral[400]};
        `,
        danger: css`
            background-color: ${theme.palette.danger[400]};
        `,
        success: css`
            background-color: ${theme.palette.success[500]};
        `
    }) as const satisfies Record<NonNullable<StyledProgressBarProps['$variant']>, ReturnType<typeof css>>

export const StyledProgressbar = styled.div<StyledProgressBarProps>(
    ({theme, $rounded, $variant}) => css`
        height: 8px;
        width: 100%;
        overflow: hidden;
        ${$rounded &&
        css`
            border-radius: 4px;
        `}
        ${makeProgressbarVariantStyle(theme)[$variant]}
    `
)

export const StyledProgressbarIndicator = styled.div<StyledProgressBarProps>(
    ({theme, $rounded, $variant}) => css`
        height: 100%;
        ${makeProgressbarIndicatorVariantStyle(theme)[$variant]}
        ${$rounded &&
        css`
            border-radius: 4px;
        `}
    `
)
